/**
 * i18n namespace constants shared across all apps.
 * Each namespace maps to a JSON file (e.g., 'desktop' → desktop.json).
 */
export const I18N_NAMESPACES = {
  common: 'common',
  desktop: 'desktop',
  web: 'web',
  api: 'api',
} as const

export type I18nNamespace = (typeof I18N_NAMESPACES)[keyof typeof I18N_NAMESPACES]

export const ALL_NAMESPACES: I18nNamespace[] = Object.values(I18N_NAMESPACES)

export const DEFAULT_NAMESPACE: I18nNamespace = I18N_NAMESPACES.common
